<ng-container *ngIf="appUpdateBanner$ | async as appUpdateBanner">
  <div *ngIf="appUpdateBanner.show" class="ion-margin banner-container">
    <div>
      <p [innerHTML]="appUpdateBanner.text"></p>
      <ion-button (click)="downloadApp()" expand="block"> Download </ion-button>
    </div>
  </div>
</ng-container>
